import api from '../api/axios';

export const getSupervisors = async () => {
  const response = await api.get('supervisor/');
  return response.data;
};
export const addSupervisorUser = async data => {
  const response = await api.post('supervisor/add/', data);
  return response.data;
};
export const updateSupervisorUser = async data => {
  const response = await api.patch('supervisor/edit/', data);
  return response.data;
};

export const deleteSupervisor = async id => {
  const response = await api.delete(`/supervisor/delete/${id}/`);
  return response.data;
};
